const namespace = {
  filters: {
    navigation: {
      scrollLeftAriaLabel: "Scroll left",
      scrollRightAriaLabel: "Scroll right",
      allFiltersAriaLabel: "View all filters",
    },
    radius: {
      title: "Radius:",
      value: "{{value}} {{unit}}",
    },
    popup: {
      title: "Filters",
      description: "Please select one option",
      cta: {
        reset: "Reset All",
        apply: "Apply Filter",
      },
    },
    categories: {
      schools: "Schools",
      restaurants: "Restaurants",
      groceries: "Groceries",
      shopping: "Shopping",
      nightlife: "Nightlife",
      cafes: "Cafes",
      daycares: "Daycares",
      busStops: "Bus stops",
      metroStations: "Metro stations",
      trainStations: "Train stations",
      parks: "Parks",
      fitness: "Fitness",
      medical: "Medical",
      petCare: "Pet care",
      fuelStations: "Car fueling stations",
      activities: "Activities",
      homeImprovement: "Home improvement",
      personalCare: "Personal care",
    },
  },
} as const;

export default namespace;
